/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedTradeRewardsBenefitCardLoader_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradeRewardsBenefitCard_user">;
    readonly " $refType": "PdpSharedTradeRewardsBenefitCardLoader_user";
};
export type PdpSharedTradeRewardsBenefitCardLoader_user$data = PdpSharedTradeRewardsBenefitCardLoader_user;
export type PdpSharedTradeRewardsBenefitCardLoader_user$key = {
    readonly " $data"?: PdpSharedTradeRewardsBenefitCardLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradeRewardsBenefitCardLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCard_user",
      "args": null
    }
  ]
};
(node as any).hash = 'c9155c8f859ff8f6867b17953cb75485';
export default node;
